import styled from 'styled-components';
import { OverlayTrigger as BootstrapOverlayTrigger, Tooltip as ReactTooltip } from 'react-bootstrap';

export default {
	Tooltip : styled(ReactTooltip)`
		.tooltip-inner {
			background-color:white;
			color:black;
			border: 1px solid gray;
		},
	`,
	OverlayTrigger : styled(BootstrapOverlayTrigger).attrs(
		{placement:'top'}
	)`
	`,
	ErrorTooltip : {
		ErrorText : styled.span`
			color : red;
		`
	},
	InfoTooltip : {
		InfoText : styled.span`

		`
	}
};